export default {
	MONEYBALL_SUB_POSITIONS: 'Moneyball sub positions',
	MONEYBALL_SUB_POSITIONS_REMOVED: 'Moneyball sub positions removed',
	NEW_MONEYBALL_SUB_POSITION_CREATED: 'Moneyball sub positions created',
	UPDATED_MONEYBALL_SUB_POSITION: 'Moneyball sub positions updated',
};
